namespace GeniuzPOS.AdvPromo {
    export enum CouponTypeFg {
        CouponTypeFg1 = 1,
        CouponTypeFg2 = 2,
        CouponTypeFg3 = 3,
        CouponTypeFg4 = 4
    }
    Serenity.Decorators.registerEnumType(CouponTypeFg, 'GeniuzPOS.AdvPromo.CouponTypeFg');
}
